import "./qa-responsive.scss";

import * as React from "react";

import {MEDIA_QUERY_MOUSE, MEDIA_QUERY_SM, ViewportTest} from "@Common/ui-components/viewport-test";

import React, { useState, useEffect } from "react";

export const QAResponsiveRoute = () => {
    const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const updateWindowDimensions = () => {
        setWindowDimensions({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };

    useEffect(() => {
        window.addEventListener("resize", updateWindowDimensions);
        return () => window.removeEventListener("resize", updateWindowDimensions);
    }, []);

    return (
        <div className="qa-responsive-2ad71a">
            <h1>CSS</h1>
            <div className="desktop">On desktop</div>
            <div className="mobile">On mobile</div>
            <div className="sm">Small screen</div>
            <div className="lg">Large screen</div>

            <h2>Window Dimensions</h2>
            <div className="window-dimensions">
                <div>Width: {windowDimensions.width}</div>
                <div>Height: {windowDimensions.height}</div>
            </div>

            <h2>Screen Dimensions</h2>
            <div className="window-dimensions">
                <div>Width: {screen.width}</div>
                <div>Height: {screen.height}</div>
            </div>

            <h1>Component</h1>
            <ViewportTest if={MEDIA_QUERY_MOUSE} then={renderDesktop} else={renderMobile} />
            <ViewportTest if={MEDIA_QUERY_SM} then={renderSmall} else={renderLarge} />
        </div>
    );
};

const renderDesktop = () => <div>On Desktop</div>;
const renderMobile = () => <div>On Mobile</div>;

const renderSmall = () => <div>Small screen</div>;
const renderLarge = () => <div>Large screen</div>;
